// @ts-ignore

import './Form.sass';

import React, { FC, ReactNode } from 'react';
import { FormItemProps } from '$uikit/Form/interface';
import { classNames as cn } from '$utils';

export const Form: FC<{ children: ReactNode; className?: string; style?: any }> = ({
  children,
  className,
  style,
}) => {
  return (
    <div className={cn('Form', className)} style={style}>
      {children}
    </div>
  );
};

export const FormItem: FC<FormItemProps> = (props) => {
  const {
    children,
    className,
    title = null,
    description = null,
    descriptionAlign = 'left',
    descriptionBeforeContent = false,
    attention = false,
    skipPadding = false,
    minimize = false,
    titleAfter = null,
  } = props;

  const renderDescription = () => (
    <div
      className={cn('Form__item__description', descriptionAlign, {
        attention: attention,
        descriptionBeforeContent: descriptionBeforeContent,
      })}
    >
      {description}
    </div>
  );

  return (
    <div
      className={cn('Form__item', className, {
        Form__item: true,
        skipPadding,
        minimize,
      })}
    >
      <div className="Form__item__header">
        {title && <div className="Form__item__title">{title}</div>}
        {titleAfter && <div className="Form__item__title_after">{titleAfter}</div>}
      </div>
      {descriptionBeforeContent && description && renderDescription()}
      <div className="Form__item__cont">{children}</div>
      {!descriptionBeforeContent && description && renderDescription()}
    </div>
  );
};

export const FormItemColumn: FC = ({ children }) => {
  return <div className="Form__item__column">{children}</div>;
};
